import { Injectable, inject } from "@angular/core";
import { HttpService } from "@app/core/services/http/http.service";
import { IPLUS_URL } from "@app/shared/constants/url.constants";
import { ThemesAdapter, Theme, ThemeManager, ThemeAdapter } from "@admin/theme-manager/theme-manager.model";
import { of, map, catchError } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ThemeManagerService {
  private http = inject(HttpService);

  /**
   * Return a list of themes
   */
  fetchThemes() {
    const themesAdapter = new ThemesAdapter();
    return this.http.get<Theme>(IPLUS_URL.THEMES_LIST).pipe(map((response: any) => themesAdapter.adapt(response)));
  }

  /**
   * gets a specific theme by its name
   * @param params
   */
  fetchThemeById(parms: ThemeManager) {
    const themeAdapter = new ThemeAdapter();
    return this.http
      .addDataParams({ themeId: parms.themeId })
      .get<ThemeManager>(IPLUS_URL.THEMES_MAINTENANCE)
      .pipe(map((response: any) => themeAdapter.adapt(response)))
      .pipe(catchError(() => of(null)));
  }

  /**
   * Add a theme
   * @param data : payload to send back to the server
   */
  addTheme(data: ThemeManager) {
    const themeAdapter = new ThemeAdapter();
    return this.http
      .addDataParams(data)
      .post(IPLUS_URL.THEMES_MAINTENANCE, "")
      .pipe(map((response: any) => themeAdapter.adapt(response)));
  }

  /**
   * Update an existing theme
   * @param data : payload to send back to the server
   */
  updateTheme(data: ThemeManager) {
    const themeAdapter = new ThemeAdapter();
    return this.http
      .addDataParams(data)
      .put(IPLUS_URL.THEMES_MAINTENANCE, "")
      .pipe(map((response: any) => themeAdapter.adapt(response)));
  }

  /**
   * Delete a theme
   * @param data
   */
  deleteTheme(data: Theme) {
    const themeAdapter = new ThemeAdapter();
    return this.http
      .addDataParams(data)
      .delete(IPLUS_URL.THEMES_DELETE)
      .pipe(map((response: any) => themeAdapter.adapt(response)));
  }
}
